// Converts WooCommerce's native variation <select> (kept for
// wc-add-to-cart-variation.js, WC's own core script) into a row of buttons,
// per woocommerce/single-product/add-to-cart/variable.php. Clicking a button
// sets the real <select> value and fires a native 'change' so WooCommerce's
// own price/stock/image matching logic runs unmodified.
//
// Needs WordPress core's real jQuery instance (see wp-jquery.js) — NOT the
// bare `$` global from this webpack bundle (that one's for Slick, see
// hero-slider.js/product-slider.js) — since wc-add-to-cart-variation.js is
// registered against the WP-core copy and won't see events triggered on a
// different jQuery instance, even on the same DOM node.

import { getRealJQuery } from '../wp-jquery';

function buildButtons($, $variation) {
    const $select = $variation.find('.pdp-variation__native select');
    const $buttons = $variation.find('[data-pdp-variation-buttons]');
    const $selectedLabel = $variation.find('[data-pdp-variation-selected]');
    if (!$select.length || $buttons.data('built')) return;

    $select.find('option').each(function () {
        const $opt = $(this);
        const value = $opt.attr('value');
        if (!value) return; // skip the "Choose an option" placeholder

        const $btn = $('<button type="button" class="pdp-variation__btn"></button>')
            .text($opt.text())
            .attr('data-value', value);

        $btn.on('click', () => {
            $select.val(value).trigger('change');
            $buttons.find('.pdp-variation__btn').removeClass('pdp-variation__btn--active');
            $btn.addClass('pdp-variation__btn--active');
            $selectedLabel.text($opt.text());
        });

        $buttons.append($btn);
    });

    $buttons.data('built', true);

    // Keep buttons in sync if WooCommerce's own JS changes the select
    // (e.g. its "Clear" link, or restoring a previously selected value).
    $select.on('change', () => {
        const current = $select.val();
        $buttons.find('.pdp-variation__btn').each(function () {
            const $btn = $(this);
            const isActive = $btn.attr('data-value') === current;
            $btn.toggleClass('pdp-variation__btn--active', isActive);
            if (isActive) $selectedLabel.text($btn.text());
        });
        if (!current) $selectedLabel.text('');
    });
}

function init() {
    const realJQuery = getRealJQuery();
    if (!realJQuery) return;
    const $ = realJQuery;

    $('.pdp-variations').each(function () {
        const $form = $(this);
        $form.find('.pdp-variation').each(function () {
            buildButtons($, $(this));
        });
    });
}

export default { init };
